import { render, staticRenderFns } from "./ResponsablesWrapper.vue?vue&type=template&id=71e60959"
import script from "./ResponsablesWrapper.vue?vue&type=script&lang=js"
export * from "./ResponsablesWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports